import styled, { keyframes } from "styled-components";
import React from "react";
import EmptyImage from "assets/images/UI/no_data.svg";
import { usePageTranslations } from 'hooks/usePageTranslations';

const Empty = ({ addMargin = true }) => {
  const t = usePageTranslations('app/audit/simple/components/EmptyFeedback/translations');
  
  return (
    <Container addMargin={addMargin}>
      <IMG src={EmptyImage} height={250} width={250} />
      <Text>{t('noDataAvailable')}</Text>
      <P>
        {t('pleaseCheckBack')}
      </P>
    </Container>
  );
};

export default Empty;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: ${({ addMargin }) => (addMargin ? "100px" : "0")};
`;

const IMG = styled.img`
  width: 300px;
`;

const Text = styled.div`
  font-family: "Poppins";
  font-weight: bold;
  font-size: 20px;
  margin-top: 20px;
`;

const P = styled.div`
  font-family: "Poppins";
  font-weight: 400;
  font-size: 14px;
  max-width: 600px;
  margin-top: 10px;
  line-height: 1.5;
  text-align: center;
`;
